/**
 * The firing-range ring round a selected formation.
 *
 * Owner, 2026-09-11: *"Jag bad om en range-ring när jag klickar på enhet som
 * påvisar hur långt den skjuter."* Drawn as a circle on the ground, not in
 * degrees: at Gävle (60°N) a degree of longitude is half the distance of a
 * degree of latitude, and a ring drawn in degrees would be an ellipse.
 */

const EARTH_M = 6371008.8;

/** Closed ring of [lon, lat] points `radiusM` from the centre, clockwise from north. */
export function rangeRing(lat: number, lon: number, radiusM: number, steps = 96): [number, number][] {
  const phi1 = (lat * Math.PI) / 180;
  const lambda1 = (lon * Math.PI) / 180;
  const delta = radiusM / EARTH_M;
  const pts: [number, number][] = [];
  for (let i = 0; i < steps; i++) {
    const theta = (2 * Math.PI * i) / steps;
    const phi2 = Math.asin(
      Math.sin(phi1) * Math.cos(delta) + Math.cos(phi1) * Math.sin(delta) * Math.cos(theta),
    );
    const lambda2 =
      lambda1 +
      Math.atan2(
        Math.sin(theta) * Math.sin(delta) * Math.cos(phi1),
        Math.cos(delta) - Math.sin(phi1) * Math.sin(phi2),
      );
    pts.push([(lambda2 * 180) / Math.PI, (phi2 * 180) / Math.PI]);
  }
  pts.push(pts[0]);
  return pts;
}

/** One breath of the pulse, in milliseconds. */
export const PULSE_MS = 1600;

/**
 * The ring's edge at time `tMs`: a slow breath rather than a blink, so it reads
 * as "this is live" without pulling the eye off everything else on the map.
 */
export function ringPulse(tMs: number): { opacity: number; width: number } {
  const t = ((tMs % PULSE_MS) + PULSE_MS) % PULSE_MS;
  const phase = (1 - Math.cos((2 * Math.PI * t) / PULSE_MS)) / 2;
  return { opacity: 0.3 + 0.55 * phase, width: 1.6 + 2.2 * phase };
}
